import { getFromLocalStorageAndDecrypt } from '../../Components/WebChat/WebChatEncryptDecrypt';
import { showErrorToast, showSucessToast } from '../../channels/utils';
import { REACT_APP_API_URL } from '../../Components/processENV';
import { string } from 'prop-types';
import { WALLPAPER_COLOR_CODES } from '../../Helpers/Constants';

export const handleWallpaperColorPost = async (wallpaperColor, image) => {

    try {
       const authUser = getFromLocalStorageAndDecrypt('auth_user');
       const token = getFromLocalStorageAndDecrypt('token');
       if (!authUser || !authUser.username) {
          showErrorToast('User authentication is missing');
          return;
       }

       if (!token) {
          showErrorToast('Authorization token is missing');
          return;
       }
       const ApiUrl = `${REACT_APP_API_URL}/users/chatBackground`;
       const controller = new AbortController();
       
       try {
          const joinResponse = await fetch(ApiUrl, {
             method: 'POST',
             headers: {
                'username': authUser.username,
                'userdomain': REACT_APP_API_URL,
                'Content-Type': 'application/json',
                'Authorization': token,
             },
             body: JSON.stringify([
               {
                   username: typeof authUser.username === string ? authUser.username : authUser.username.toString(),
                   chatUser: "",
                   chatType: "default",
                   platform: "web",
                   deviceId: "",
                   themeColorHex: wallpaperColor ? wallpaperColor : WALLPAPER_COLOR_CODES[0],
                   imageUrl: image ? image : "",
                   fileToken: ""
               }
           ]
           ),
             signal: controller.signal,
          });


          const joinData = await joinResponse.json();

          if (joinResponse.ok && (joinData.status === 200 || joinData.statusCode === 200)) {
             
                showSucessToast('Wallpaper applied successfully');
          } else {
             showErrorToast('Failed to apply wallpaper. Please try again.');
          }
       } catch (fetchErr) {
         showErrorToast('Failed to apply wallpaper. Please try again.');
             throw fetchErr;
            }
         } catch (error) {
            showErrorToast('Network error occurred. Please try again.');
            throw error;
    }
 };
